<template>
  <div>
    <b-carousel
      v-model="slide"
      :interval="4000"
      controls
      indicators
      style="text-shadow: 1px 1px 2px #333;"
      class="rounded overflow-hidden w-100 h-100"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <b-carousel-slide class="w-100 h-100">
        <template v-slot:img>
          <b-aspect aspect="8:3">
            <img
              class="d-block w-100 position-absolute"
              width="0"
              height="0"
              style="width: 100%; height: 100%"
              src="../../assets/rushan_2.jpeg"
              alt="image slot"
            >
          </b-aspect>
        </template>
        <h2 class="d-none d-md-block">大乳山旅游度假区</h2>
      </b-carousel-slide>
      <b-carousel-slide>
        <template v-slot:img>
          <b-aspect aspect="8:3">
            <img
              class="d-block w-100 position-absolute"
              width="1024"
              height="420"
              src="../../assets/rushan_1.jpeg"
              alt="image slot"
            >
          </b-aspect>
        </template>
        <h2 class="d-none d-md-block">银滩旅游度假区</h2>
      </b-carousel-slide>
      <b-carousel-slide>
        <template v-slot:img>
          <b-aspect aspect="8:3">
            <img
              class="d-block w-100 position-absolute"
              width="1024"
              height="420"
              src="../../assets/rushan_2.jpeg"
              alt="image slot"
            >
          </b-aspect>
        </template>
        <h2 class="d-none d-md-block">大乳山旅游度假区</h2>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        slide: 0,
        sliding: null
      }
    },
    methods: {
      onSlideStart(slide) {
        slide
        this.sliding = true
      },
      onSlideEnd(slide) {
        slide
        this.sliding = false
      }
    }
  }
</script>